import React from 'react';
import Grid, { GridProps } from '@mui/material/Grid';

export function AreaLeftSide<C extends React.ElementType>(props: GridProps<C, { component?: C }>) {
  const defaults = {
    item: true,
    xs: 12,
    md: 8,
    lg: 9,
  };

  return <Grid {...{ ...defaults, ...props }} />;
}
